// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dj-3";
export var flatBottomCorners = "_dj-5";
export var productImage = "_dj-0";
export var quantityContainer = "_dj-2";
export var quantityHeader = "_dj-6";
export var tooltip = "_dj-1";
export var wrapAndEllipsesOverflow = "_dj-4";